import React from "react";

const TermsSkeleton: React.FC = () => {
  return (
    <section className="section relative text-white p-14 max-sm:p-4 blue-bg-dots min-h-[calc(100vh-260px)] custom-contain">
      <div className="container ">
        <h1 className="text-8xl max-md:text-4xl text-start mb-20 max-md:mb-10">
          <div className="h-10 w-2/6 bg-gray-300 skeleton rounded"></div>
        </h1>
        <div className="text-2xl max-md:text-lg text-primary">
          {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15].map((item) => {
            return (
              <div
                key={item}
                className="skeleton w-full h-6 my-5 !rounded-md"
              ></div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
export default TermsSkeleton;
